import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import BasicTable from 'components/BasicTable';
import { getActivities, getActivityDates, setActiveDates } from 'state/reducers/activity.reducers';
import {
  ActivityDashboardTableColumns,
  ActivityEnum,
  ActivityTableColumns,
  ActivityTypes,
  RequestDashboardTableColumns,
} from 'constants/activity.constants';
import { columnType, FilterType } from 'components/BasicTable/types';
import _ from 'lodash';
import { filterDates } from 'components/formElements/DateRange';
import { convertType } from 'constants/convert.constants';
import { getDay, timing } from 'constants/ui.constants';
import { Box } from '@mui/material';
import { getAllRequests } from 'state/reducers/requests.reducers';
import { format, isValid } from 'date-fns';

export default function RequestsTable() {
  const t = useAppSelector(selectTranslations);
  const requests = _.orderBy(_.flatten(_.values(useAppSelector(getAllRequests))), ['date'], ['desc']);

  const activitiesColumns = () => {
    let columns: columnType[] = [];
    _.keys(RequestDashboardTableColumns).forEach((element) => {
      let props: columnType = {
        fieldId: ActivityEnum.reference,
        name: element,
        title: t('forms.activity.field.' + element),
        type: ActivityTableColumns[element],
        formatDate: _.isEqual(ActivityEnum.settlementDate, element) ? timing.DATE : undefined,
      };
      columns.push(props);
    });
    return columns;
  };

  const formatValues = (list) => {
    let activities: any[] = [];
    list.forEach((item) => {
      let cl = _.clone(item);
      _.assign(cl, {
        status: t('page.dashboard.pending_requests.field.status.' + _.snakeCase(item.status) + '.text'),
      });
      _.assign(cl, {
        category: t(
          'page.dashboard.pending_requests.field.category.' + _.snakeCase(String(item.category)) + '.text'
        ),
      });
      _.assign(cl, {
        date: [timing.TODAY, timing.YESTERDAY].includes(getDay(item.date) as timing)
          ? t('page.dashboard.timing.' + getDay(item.date) + '.text')
          : getDay(item.date),
      });
      activities.push(cl);
    });
    return activities;
  };

  return (
    <Box
      sx={{
        '& .MuiTableCell-root:last-child': {
          width: '100%',
          textAlign: 'end',
          paddingRight: '8px',
        },
      }}
    >
      <BasicTable
        fieldId="id"
        hideHeader
        data={formatValues(requests)}
        columns={activitiesColumns()}
        defaultSortBy="date"
        perPage={5}
        noPagination
        noShrink
        tableClass="simple"
      />
    </Box>
  );
}
